import { observer } from "mobx-react-lite";
import React from "react";
import { SiteModalToolbarBtn } from "../company/SiteModalToolbarBtn";

export const ItemRole = observer(({ role, moveRole, removeRole }) => {
  return (
    <div className="admin-role-row">
      <button
        type="button"
        className="admin-role-row-name"
        onClick={() => moveRole(role)}
      >
        {role.role_name}
      </button>
      <SiteModalToolbarBtn
        variant="delete"
        onClick={() => removeRole(role)}
        title="Удалить роль"
      />
    </div>
  );
});
